import {
  CHECK_IF_LOGGED_IN_BEGIN,
  CHECK_IF_LOGGED_IN,
  CHECK_IF_LOGGED_IN_FAILURE,
  CHECK_IF_HAS_SUBSCRIPTION_BEGIN,
  CHECK_IF_HAS_SUBSCRIPTION,
  CHECK_IF_HAS_SUBSCRIPTION_FAILURE,
  ADD_IMPORT_BEGIN,
  ADD_IMPORT,
  ADD_IMPORT_FAILURE,
  HIDE_ERROR,
} from 'constants/actionTypes';

const initialState = {
  loading: false,
  errors: null,
  displayError: false,
  startedActionsCounter: 0,
};

export default function app(state = initialState, action) {
  let actionsCounter = 0;

  switch (action.type) {
    case CHECK_IF_LOGGED_IN_BEGIN:
    case CHECK_IF_HAS_SUBSCRIPTION_BEGIN:
    case ADD_IMPORT_BEGIN:
      return {
        ...state,
        loading: true,
        errors: null,
        displayError: false,
        startedActionsCounter: state.startedActionsCounter + 1,
      };

    case CHECK_IF_LOGGED_IN:
    case CHECK_IF_HAS_SUBSCRIPTION:
    case ADD_IMPORT:
      actionsCounter = state.startedActionsCounter - 1;

      return {
        ...state,
        loading: actionsCounter !== 0,
        startedActionsCounter: actionsCounter,
      };

    case CHECK_IF_LOGGED_IN_FAILURE:
    case CHECK_IF_HAS_SUBSCRIPTION_FAILURE:
    case ADD_IMPORT_FAILURE:
      actionsCounter = state.startedActionsCounter - 1;
      return {
        ...state,
        loading: actionsCounter !== 0,
        errorMessage: action.payload.error.message,
        displayError: true,
        startedActionsCounter: actionsCounter,
      };

    case HIDE_ERROR:
      return {
        ...state,
        displayError: false,
      };

    default:
      return state;
  }
}
